import { propAccessor } from '@hc-frontend/utils'
import getMultiCarrierEligibility from 'core/services/getMultiCarrierEligibility'
import store from 'utils/store/withMiddleware'
import { enableMultiCarrierPlans } from 'utils/experiments'

export type UpdateMultiCarrierEligibilityOptional = {
  stateAcronym?: string
}

export default async (
  state: Pivot.State,
  optional?: UpdateMultiCarrierEligibilityOptional
) => {
  if (enableMultiCarrierPlans() && !state.signedDetails) {
    const stateAcronym =
      propAccessor(optional, 'stateAcronym') ||
      propAccessor(state, 'hcStorage.location.state_acronym')
    const agentId = propAccessor(state, 'hcStorage.agent_id')

    const multiCarrierEligibility = await getMultiCarrierEligibility(
      stateAcronym,
      agentId
    )

    if (!multiCarrierEligibility.error)
      return store.update({
        eligibilityMonths: multiCarrierEligibility.maxDuration,
        eligibilityBool: multiCarrierEligibility.multiCarrier
      })

    return store.update({
      eligibilityMonths: null,
      eligibilityBool: false
    })
  } else {
    return state
  }
}
